import { useEffect, useState } from 'react'
import { PhoneFrame } from './shell/PhoneFrame'
import { Shell } from './shell/Shell'
import { Login } from './auth/Login'
import { ChooseCoach } from './auth/ChooseCoach'
import { TooltipProvider } from '@/components/ui/Tooltip'
import { AIAvatar } from '@/components/ui/AIAvatar'
import { clearToken, fetchMe, type User } from './api/auth'

const get = (k: string) => { try { return localStorage.getItem(k) } catch { return null } }
const set = (k: string, v: string) => { try { localStorage.setItem(k, v) } catch { /* ignore */ } }

export function App() {
  const [user, setUser] = useState<User | null>(null)
  const [checking, setChecking] = useState(true)
  const [coach, setCoach] = useState<string | null>(() => get('sara-coach'))
  const [dark, setDark] = useState(() => get('sara-theme') === 'dark')

  useEffect(() => { fetchMe().then((u) => { setUser(u); setChecking(false) }) }, [])

  const chooseCoach = (id: string) => { set('sara-coach', id); setCoach(id) }
  const toggleDark = () => setDark((d) => { const n = !d; set('sara-theme', n ? 'dark' : 'light'); return n })
  const signOut = () => { clearToken(); setUser(null) }

  let screen: React.ReactNode
  if (checking) {
    screen = (
      <div className="flex h-full items-center justify-center bg-background">
        <span className="sara-star"><AIAvatar size="lg" /></span>
      </div>
    )
  } else if (!user) {
    screen = <Login onAuth={setUser} />
  } else if (!coach) {
    screen = <ChooseCoach onChoose={chooseCoach} current={coach} />
  } else {
    screen = (
      <Shell user={user} coach={coach} dark={dark} onToggleDark={toggleDark}
        onChangeCoach={() => setCoach(null)} onSignOut={signOut} />
    )
  }

  return (
    <TooltipProvider>
      <PhoneFrame dark={dark}>{screen}</PhoneFrame>
    </TooltipProvider>
  )
}
